import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(private readonly appConfig: AppConfig) {}

  /**
   * Returns the display language based on user preference and supported languages
   * @param userLanguagePreference - The user's language preference
   * @param supportedLanguages - Array of supported language codes. Defaults to [EN, HI]
   * @param defaultLanguage - Default language to fallback to. Defaults to EN
   * @returns The display language code
   */
  getDisplayLanguage(
    userLanguagePreference: string,
    supportedLanguages?: string[],
    defaultLanguage?: string
  ): string {
    const { EN: ENGLISH, HI: HINDI } = this.appConfig.Shared.Languages;
    const languages = supportedLanguages || [ENGLISH, HINDI];
    const defaultLang = defaultLanguage || ENGLISH;

    if (!userLanguagePreference || !languages.includes(userLanguagePreference)) {
      return defaultLang;
    }

    return userLanguagePreference;
  }
}
